import { useState, useEffect, useCallback } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { Location } from 'history';

export interface RouteBlockProps {
    userConfirmationCallback?: (ok: boolean) => void;
}

/**
 * 拦截取消location变化，等待动画完成或确认后再次触发close再放行location变化
 * @param props userConfirmationCallback仅当history.goBack()时有值
 * @returns closing是否收到location变化准备关闭，close确认关闭，setClosing主要用于重置待关闭状态
 */
export const useRouteBlock = (
    props: RouteComponentProps & RouteBlockProps
): { closing: boolean; confirmClose: () => void; cancelClose: () => void } => {
    const [closing, setClosing] = useState(false);
    const [closed, setClosed] = useState(false);
    useEffect(() => {
        if (props.userConfirmationCallback && props.match.isExact) {
            if (closed) props.userConfirmationCallback(true);
            else {
                setClosing(true);
                props.userConfirmationCallback(false);
            }
        }
    }, [props.userConfirmationCallback]);
    const confirmClose = useCallback(() => {
        setClosed(true);
        props.history.goBack();
    }, []);
    const cancelClose = useCallback(() => {
        setClosing(false);
    }, []);
    return {
        closing: closing,
        confirmClose,
        cancelClose
    };
};

export const useRouteConfirmationCallback = (): {
    block: (location: Location, action: string) => string;
    getUserConfirmation: (message: string, callback: (ok: boolean) => void) => void;
    userConfirmationCallback?: (ok: boolean) => void;
} => {
    const [userConfirmationCallback, setUserConfirmationCallback] = useState<
        (ok: boolean) => void
    >();
    const block = useCallback((_location: Location, action: string) => {
        return action;
    }, []);

    // 包装userConfirmationCallback，调用后清除。
    const confirmThenClear = useCallback(
        (ok: boolean) => {
            if (userConfirmationCallback) {
                setUserConfirmationCallback(undefined);
                userConfirmationCallback(ok);
            }
        },
        [userConfirmationCallback]
    );

    const getUserConfirmation = useCallback((message: string, callback: (ok: boolean) => void) => {
        if (message === 'POP') {
            setUserConfirmationCallback(() => callback);
        } else {
            callback(true);
        }
    }, []);
    return {
        block,
        getUserConfirmation,
        userConfirmationCallback: userConfirmationCallback && confirmThenClear
    };
};
